import React from 'react';

export const whyChooseUsReasons = [
	{
		title: 'Super Mom Champions',
		subtitle: 'A mother of a special needs child is the best therapist we know of. So, we strive to hire and rigorously train single mothers of special needs children, with a path to partnership in the clinic so that no mother must struggle with conflicting priorities of childcare, financial security & career.',
		icon: (
			<svg
				height={24}
				width={24}
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01' />
			</svg>
		)
	},
	{
		title: 'Family-centered care team',
		subtitle: 'Every child is special and unique. Parents know the child better than anyone. So, we insist on an active role of parents in their child’s development. We seek parent’s perspective and input to collectively give a child the best care possible.',
		icon: (
			<svg
				height={24}
				width={24}
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z' />
			</svg>
		)
	},
	{
		title: 'Community Approach',
		subtitle: 'Not every child is able to come to our clinic. That’s why we serve our communities outside of our walls with:',

		hasList: true,
		list: [
			'Community Sessions - training, activity-based workshops and AskTheExpert',
			'Community Events - hosted by our care team to help parents and children learn skills in a naturalistic environment such as Christmas or birthday celebrations or restaurants or shopping malls.',
			'Home & Telehealth allow parents and children to seek our help at home or virtually',
			'Sponsored care if a parent cannot afford care',
			'Legislative advocacy'
		],
		icon: (
			<svg
				height={24}
				width={24}
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z' />
			</svg>
		)
	},
	{
		title: 'Quality care',

		subtitle: 'We are the only high-touch clinic with neuroscientists analyzing, guiding, and working closely with care teams – BCBA and therapists. We have the resources, experience, education and most importantly ‘the heart’ to care for your child.',
		icon: (
			<svg
				height={24}
				width={24}
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'>
				<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M13 10V3L4 14h7v7l9-11h-7z' />
			</svg>
		)
	},
	{
		title: 'Age appropriate / Lifetime / Comprehensive care',
		subtitle: 'At SimSouls, we are by your side at every step of your child’s life journey. To achieve this goal, we aspire to offer age appropriate and comprehensive support that includes - developmental screening & therapies, parent ed programs, specialized nannies/babysitters, day care, special ed school, summer camp and group living.',
		icon: (
			<svg
				height={24}
				width={24}
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15' />
			</svg>
		)
	},
	{
		title: 'Research Led and Data driven Approach',
		subtitle: 'Our therapy is led by cutting-edge brain research with neuroscientists analyzing, guiding, and working closely with care teams – BCBA and therapists. Our top-notch experts deploy the latest in research to maximize outcomes for your child.',
		icon: (
			<svg
				height={24}
				width={24}
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15' />
			</svg>
		)
	}
];
